import React from 'react';
import '../styles/Root.css';
import '../styles/Header.css';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

const DonationCancel = () => {
  return (
    <div>
      <div className="cancel-container">
        <div className="cancel-icon">
          <i className="fas fa-times-circle"></i>
        </div>
        <h1>Don annulé</h1>
        <p>Votre don a été annulé et aucun frais ne vous sera facturé.</p>
        <p>Si vous avez des questions ou besoin d'une assistance, n'hésitez pas à <a href="mailto:amisdumusee@wanadoo.fr" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'var(--tdm-blue)', fontWeight: 700 }}>nous contacter</a>.</p>
        <p>Nous vous remercions pour votre compréhension.</p>
        <Link to="/" className="return-btn">Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default DonationCancel;
